module.exports = __webpack_public_path__ + "img/fas-caret-left.23fa6997.svg";